import { render, staticRenderFns } from "./noticebar.vue?vue&type=template&id=dd27ee08&"
import script from "./noticebar.vue?vue&type=script&lang=js&"
export * from "./noticebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports